export const WIDGET_ID = 'de10399c-2126-47f9-bdd1-3d35d5162e4a'
export const LOCAL_STORAGE_PARAMS_KEY = `pp-widget-params-${WIDGET_ID}`
